import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Auth } from '@freelancer/auth';
import {
  Bid,
  Datastore,
  ProjectViewProject,
  ProjectViewUser,
} from '@freelancer/datastore';
import { ModalRef } from '@freelancer/ui';
import { ProjectTypeApi } from 'api-typings/projects/projects';
import * as Rx from 'rxjs';
import { map } from 'rxjs/operators';

interface Payload {
  bid: Bid;
  user: ProjectViewUser;
  project: ProjectViewProject;
}

@Component({
  template: `
    <fl-bit class="Container">
      <ng-container *ngIf="(payload$ | async) as payload; else Loading">
        <app-hourly-hourly-award-modal *ngIf="payingHourly"
          [bid]="payload.bid"
          [user]="payload.user"
          [project]="payload.project"
          (switchAwardType)="switchAwardType($event)"
        ></app-hourly-hourly-award-modal>
        <app-hourly-fixed-award-modal *ngIf="!payingHourly"
          [bid]="payload.bid"
          [user]="payload.user"
          [project]="payload.project"
          (switchAwardType)="switchAwardType($event)"
        ></app-hourly-fixed-award-modal>
      </ng-container>
      <ng-template #Loading>
        <fl-spinner
          [overlay]="true"
        ></fl-spinner>
      </ng-template>
    </fl-bit>
  `,
  styleUrls: ['./hourly-award-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HourlyAwardModalComponent implements OnInit {
  @Input() bidId: number;

  payingHourly: boolean;

  bid$: Rx.Observable<Bid>;
  user$: Rx.Observable<ProjectViewUser>;
  project$: Rx.Observable<ProjectViewProject>;
  payload$: Rx.Observable<Payload>;

  constructor(
    private datastore: Datastore,
    private auth: Auth,
    private modalRef: ModalRef<HourlyAwardModalComponent>,
  ) {}

  ngOnInit() {
    this.payingHourly = true;

    const userId$ = this.auth.getUserId();

    this.bid$ = this.datastore.object('bids', userId$, this.bidId);

    this.user$ = this.datastore.object(
      'projectViewUsers',
      userId$,
      this.bid$.pipe(map(b => b.bidderId)),
    );

    this.project$ = this.datastore.object(
      'projectViewProjects',
      userId$,
      this.bid$.pipe(map(b => b.projectId)),
    );

    this.payload$ = Rx.combineLatest(this.bid$, this.user$, this.project$).pipe(
      map(([bid, user, project]) => ({
        bid,
        user,
        project,
      })),
    );
  }

  close() {
    this.modalRef.close();
  }

  switchAwardType(awardType: string) {
    this.payingHourly = awardType === ProjectTypeApi.HOURLY;
  }
}
